import { StringSchema } from 'yup';

export class BookingSchema extends StringSchema {
  id(
    messages: {
      max?: string;
      alphanumeric?: string;
    } = {}
  ) {
    return this.alphanumeric(messages?.alphanumeric).max(10, messages?.max);
  }
}

function create(): BookingSchema {
  return new BookingSchema();
}

create.prototype = BookingSchema.prototype;

export default create;
